import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-three-col-area-button',
  templateUrl: './three-col-area-button.component.html',
  styleUrls: ['./three-col-area-button.component.css']
})
export class ThreeColAreaButtonComponent implements OnInit {

  @Input() threeColAreaButton_params: any = {}

  constructor() { }

  ngOnInit(): void {
  }

}
